import React from 'react';
import { Box, IconButton } from '@mui/material';
import { DatasetLinkedOutlined } from '@mui/icons-material';

interface RobotUserSchemaButtonWrapperProps {
  children: React.ReactNode;
  onUserDataTrigger?: (
    fieldName: string,
    anchorEl: HTMLElement,
    subFieldName?: 'min' | 'max'
  ) => void;
  userdataschema?: any[];
  fieldKey: string;
  subFieldName?: 'min' | 'max';
}

export const RobotUserSchemaButtonWrapper: React.FC<RobotUserSchemaButtonWrapperProps> = ({
  children,
  onUserDataTrigger,
  userdataschema,
  fieldKey,
  subFieldName,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
      {onUserDataTrigger && userdataschema && userdataschema.length > 0 && (
        <IconButton
          onClick={(e) => onUserDataTrigger(fieldKey, e.currentTarget as HTMLElement, subFieldName)}
        >
          <DatasetLinkedOutlined />
        </IconButton>
      )}
    </Box>
  );
};
